import EventoActionTypes from "./action-types.ts";

const stateInicial = {
    evento: {},
};

const eventoReducer = (state = stateInicial, action) => {
    switch (action.type) {
        case EventoActionTypes.ACAO_EVENTO:
            return { ...state, evento: action.payload.evento };
        default: 
            return state;
    }
}

export default eventoReducer;